module.exports = __webpack_public_path__ + "img/Herus.abb01cef.png";